// frontend/src/utils/toast.ts
import { toast as baseToast } from "sonner";

type ToastType = "success" | "error" | "info" | "warning";

interface ToastOptions {
  description?: string;
  duration?: number;
}

export function showToast(
  message: string,
  type: ToastType = "info",
  options: ToastOptions = {}
) {
  const { description, duration = 3000 } = options;

  const baseOptions = {
    description,
    duration,
  };

  switch (type) {
    case "success":
      return baseToast.success(message, baseOptions);
    case "error":
      return baseToast.error(message, baseOptions);
    case "warning":
      return baseToast(message, {
        ...baseOptions,
        className: "bg-yellow-100 text-yellow-800",
      });
    case "info":
    default:
      return baseToast(message, baseOptions);
  }
}